import { render, staticRenderFns } from "./map.vue?vue&type=template&id=862d585e&"
import script from "./map.vue?vue&type=script&lang=js&"
export * from "./map.vue?vue&type=script&lang=js&"
import style0 from "./map.vue?vue&type=style&index=0&id=862d585e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Sulu: require('/opt/yamal.ru/node_modules/razlet-sulu-sdk/src/components/index.vue').default})
